import type { ResourceLanguage } from './resources'

export const RESOURCE_COPY = {
  en: {
    eyebrow: 'RESOURCES',
    indexTitle: 'Guides to finding customers and getting replies',
    indexDescription:
      'How to find the people who buy, reach them from your own mailbox and decide who to sell to first — from what we learn running Laplace GTM.',
    startHere: 'Start here',
    featuredResource: 'Featured resource',
    readResource: 'Read resource',
    resources: 'Resources',
    breadcrumbLabel: 'Breadcrumb',
    keyTakeaways: 'Key takeaways',
    onThisPage: 'On this page',
    tableOfContents: 'Table of contents',
    updated: 'Updated',
    relatedResources: 'Related resources',
    locale: 'en-US',
  },
  ru: {
    eyebrow: 'МАТЕРИАЛЫ',
    indexTitle: 'Практические материалы о внедрении AI в реальные процессы',
    indexDescription:
      'Узнайте, как находить возможности для AI, создавать управляемых агентов и измерять их влияние.',
    startHere: 'Начните здесь',
    featuredResource: 'Рекомендуемый материал',
    readResource: 'Читать материал',
    resources: 'Материалы',
    breadcrumbLabel: 'Навигационная цепочка',
    keyTakeaways: 'Главное',
    onThisPage: 'В этом материале',
    tableOfContents: 'Оглавление',
    updated: 'Обновлено',
    relatedResources: 'Похожие материалы',
    locale: 'ru-RU',
  },
} as const satisfies Record<ResourceLanguage, Record<string, string>>
